<template>
  <div class="section-hub" :class="{ 'section-hub--wide': wide }">
    <SectionHeader :section-key="sectionKey" />
    <slot>
      <router-view />
    </slot>
  </div>
</template>

<script>
import SectionHeader from './SectionHeader.vue'

/** 板块统一框架：页头（板块名 / 子页说明 / 子页标签）+ 子路由内容。 */
export default {
  name: 'SectionHub',
  components: { SectionHeader },
  props: {
    sectionKey: { type: String, required: true },
    wide: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.section-hub {
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 1460px;
  width: 100%;
}

.section-hub--wide {
  max-width: none;
}

/* 板块内所有 el-card 与全站面板同一视觉：细描边、大圆角、轻阴影 */
.section-hub :deep(.el-card) {
  border-color: var(--mp-border);
  border-radius: var(--mp-radius-lg);
}

.section-hub :deep(.el-card.is-always-shadow),
.section-hub :deep(.el-card.is-hover-shadow:hover) {
  box-shadow: var(--mp-shadow-sm);
}
</style>
